export class ResponseTemplateDto {
  id: number;
  name: string;
  category: string;
  description: string;
  merchants: { pieMerchantId: number }[];
  createdDate: Date;
  startDate: Date;
  endDate: Date;
  active: boolean;
  content: string;
  pieBrandId: number;
  brandName?: string;
}
